import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: '4em',
    }
});